export default "__VITE_ASSET__gq$CDEu3__"